export default __webpack_public_path__ + "static/media/icon_phone_32.674290c5.svg";